import { render, staticRenderFns } from "./SalaryReceiptList.vue?vue&type=template&id=6faf0d02&scoped=true&"
import script from "./SalaryReceiptList.vue?vue&type=script&lang=js&"
export * from "./SalaryReceiptList.vue?vue&type=script&lang=js&"
import style0 from "./SalaryReceiptList.vue?vue&type=style&index=0&id=6faf0d02&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6faf0d02",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/elopez/repos/FacturaIzzi/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6faf0d02')) {
      api.createRecord('6faf0d02', component.options)
    } else {
      api.reload('6faf0d02', component.options)
    }
    module.hot.accept("./SalaryReceiptList.vue?vue&type=template&id=6faf0d02&scoped=true&", function () {
      api.rerender('6faf0d02', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Admin/Invoices/History/SalaryReceiptList.vue"
export default component.exports